import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Reveal";

const Footer = () => (
    <footer data-testid="footer" className="relative bg-[#0A0A0A] noise-overlay py-24 md:py-32 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 border-b border-white/10 pb-16">
                <FadeUp>
                    <p className="text-xs tracking-[0.25em] uppercase font-bold text-white/40 mb-4">MeerjarenplanOnline.nl</p>
                    <p className="font-heading text-white font-bold tracking-tight text-2xl sm:text-3xl max-w-md leading-snug">
                        Investment scenario's AI — ontworpen voor vrijwilligers en professionals.
                    </p>
                </FadeUp>
                <FadeUp delay={0.15}>
                    <a
                        data-testid="footer-cta-demo"
                        href="https://app.meerjarenplanonline.nl/login"
                        className="inline-flex items-center gap-2 rounded-full bg-[#0047FF] hover:bg-[#0036CC] text-white font-bold px-8 py-4 text-sm transition-[background-color,transform] duration-300 hover:scale-[1.04]"
                    >
                        Start gratis proefperiode
                        <ArrowUpRight className="w-4 h-4" />
                    </a>
                </FadeUp>
            </div>

            <FadeUp delay={0.1}>
                <p
                    data-testid="footer-brand"
                    className="font-heading font-black tracking-tighter leading-none text-[7vw] md:text-[4.1vw] text-center whitespace-nowrap select-none mt-10"
                >
                    <span className="text-white">MEERJARENPLAN</span><span className="text-[#FF6B00]">ONLINE.NL</span>
                </p>
                <p data-testid="footer-service-line" className="mt-4 text-center text-white/40 text-sm tracking-[0.2em] uppercase">
                    een service van Club-Fin.nl
                </p>
            </FadeUp>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 text-white/40 text-xs tracking-wide">
                <span data-testid="footer-copyright">Copyright: 2026 Club-Fin.nl. Alle rechten voorbehouden.</span>
                <div className="flex items-center gap-6">
                    <a data-testid="footer-community-link" href="/community" className="hover:text-white transition-colors duration-300">
                        Community
                    </a>
                    <a data-testid="footer-app-link" href="https://app.meerjarenplanonline.nl/login" className="hover:text-white transition-colors duration-300">
                        Naar de Scenariobouwer
                    </a>
                    <a data-testid="footer-privacy-link" href="/privacy" className="hover:text-white transition-colors duration-300">
                        Privacyverklaring
                    </a>
                    <span>Gemaakt in Nederland</span>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
